<body>
  <span class="material-icons" id="material-icons">engineering</span>
  <p class="maintenance" id="maintenance">ただいま業務閉塞中です。</p>

  <p class="message" id="message">
    ただいまご利用できません。<br>
    業務閉塞終了までしばらくお待ちください。
  </p>
</body>